module.exports = app_owpp_marketValueLandingPage;